<template>
  <div class="tab-wrapper">
    <div v-show="contextMenuVisible">
      <ul :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
        <li>
          <el-button type="text" @click="curTabReload()" size="mini"
            >重新加载</el-button
          >
        </li>
        <li>
          <el-button type="text" @click="closeAllTabs()" size="mini"
            >关闭所有</el-button
          >
        </li>
        <li v-show="isDisabledCloseLeftBtnFlag">
          <el-button type="text" @click="closeOtherTabs('left')" size="mini"
            >关闭左边</el-button
          >
        </li>
        <li v-show="isDisabledCloseRightBtnFlag">
          <el-button type="text" @click="closeOtherTabs('right')" size="mini"
            >关闭右边</el-button
          >
        </li>
        <li>
          <el-button
            type="text"
            v-show="openTab.length > 2"
            @click="closeOtherTabs('other')"
            size="mini"
            >关闭其他</el-button
          >
        </li>
      </ul>
    </div>
    <el-tabs
      v-model="activeIndex"
      type="border-card"
      @tab-click="tabClick"
      @tab-remove="tabRemove"
    >
      <el-tab-pane
        v-for="(item, index) in openTab"
        :key="index"
        :label="item.name"
        :name="item.route"
        :closable="item.closable"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import StringTool from "@/utils/stringTool";
export default {
  data() {
    return {
      contextMenuVisible: false,
      left: 0,
      top: 0,
      isDisabledCloseLeftBtnFlag: false,
      isDisabledCloseRightBtnFlag: false,
      curIndex: 0,
    };
  },
  methods: {
    //tab标签点击时，切换相应的路由
    tabClick(tab) {
      this.$router.push({ path: this.activeIndex });
    },
    //移除tab标签
    tabRemove(targetName) {
      //判断是不是首页，首页不删
      if (targetName == "/") {
        return;
      }
      this.$store.commit("tabView/DEL_TAB", targetName);
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.openTab && this.openTab.length >= 1) {
          this.$store.commit(
            "tabView/SET_ACTIVE_INDEX",
            this.openTab[this.openTab.length - 1].route
          );
          this.$router.push({ path: this.activeIndex });
        } else {
          this.$router.push({ path: "/" });
        }
      }
    },
    openContextMenu(e) {
      e.preventDefault(); //防止默认菜单弹出
      let obj = e.srcElement ? e.srcElement : e.target;

      if (obj.id) {
        let path = obj.id.split("-")[1];
        let curIndex = 0;
        for (let i = 0; i < this.openTab.length; i++) {
          if (this.openTab[i].route === path) {
            curIndex = i;
            break;
          }
        }
        if (curIndex == 0 || (curIndex == 1 && this.openTab.length == 2)) {
          this.isDisabledCloseLeftBtnFlag = false;
          this.isDisabledCloseRightBtnFlag = false;
        } else if (curIndex == this.openTab.length - 1) {
          this.isDisabledCloseLeftBtnFlag = true;
          this.isDisabledCloseRightBtnFlag = false;
        } else if (curIndex == 1) {
          this.isDisabledCloseLeftBtnFlag = false;
          this.isDisabledCloseRightBtnFlag = true;
        } else if (curIndex > 1 && curIndex < this.openTab.length - 1) {
          this.isDisabledCloseLeftBtnFlag = true;
          this.isDisabledCloseRightBtnFlag = true;
        } else {
          this.isDisabledCloseLeftBtnFlag = false;
          this.isDisabledCloseRightBtnFlag = false;
        }
        this.curIndex = curIndex;
        this.contextMenuVisible = true;
        this.left = e.clientX;
        this.top = e.clientY + 10;
      }
    },
    //刷新当前页
    curTabReload() {
      location.reload();
      this.closeContextMenu();
    },
    // 关闭所有标签页
    closeAllTabs() {
      this.clearTab("all", 0);
      this.closeContextMenu();
    },
    // 关闭其它标签页
    closeOtherTabs(par) {
      this.clearTab(par, this.curIndex);
      this.closeContextMenu();
    },
    // 关闭contextMenu
    closeContextMenu() {
      this.contextMenuVisible = false;
    },
    clearTab(type, index) {
      let vm = this;
      let openTabData = JSON.parse(JSON.stringify(vm.openTab));
      let home = openTabData[0];
      let arr = [];
      let activeIndex = 1;
      if (type == "left") {
        arr = openTabData.slice(index, vm.openTab.length);
      } else if (type == "right") {
        arr = openTabData.slice(1, index + 1);
      } else if (type == "other") {
        if (openTabData.length > 1) {
          const other = openTabData[index];
          arr = [other];
        }
      } else {
        activeIndex = 0;
      }
      arr.unshift(home);
      vm.openTab = arr;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].route === vm.activeIndex) {
          activeIndex = i;
          break;
        }
      }
      vm.activeIndex = arr[activeIndex].route;
      if (vm.$route.path !== arr[activeIndex].route) {
        vm.$router.push(arr[activeIndex].route);
      }
      vm.$store.commit("tabView/SET_ACTIVE_INDEX", vm.activeIndex);
      vm.$store.commit("tabView/SET_TAB_DATA", arr);
    },
  },
  mounted() {
    // 刷新时以当前路由做为tab加入tabs
    // 当前路由不是首页时，添加首页以及另一页到store里，并设置激活状态
    // 当当前路由是首页时，添加首页到store，并设置激活状态
    if (
      this.$route.path !== "/" &&
      this.$route.path !== this.$store.state.user.main.pagePath
    ) {
      this.$store.commit("tabView/ADD_TAB", {
        route: this.$store.state.user.main.pagePath,
        name: this.$store.state.user.main.name,
      });
      let fullPath = this.$route.fullPath;
      fullPath = StringTool.escapeUrlOfStr(fullPath);
      const pageItem = this.$store.state.user.menuList.find((obj) => {
        return obj.pagePath == fullPath;
      });
      this.$store.commit("tabView/ADD_TAB", {
        route: pageItem.pagePath,
        name: pageItem.name,
        closable: true,
      });
      this.$store.commit("tabView/SET_ACTIVE_INDEX", pageItem.pagePath);
    } else {
      this.$store.commit("tabView/ADD_TAB", {
        route: this.$store.state.user.main.pagePath,
        name: this.$store.state.user.main.name,
      });
      this.$store.commit(
        "tabView/SET_ACTIVE_INDEX",
        this.$store.state.user.main.pagePath
      );
      this.$router.push(this.$store.state.user.main.pagePath);
    }

    // 获取dom
    let tab_top_dom = document.body.getElementsByClassName(
      "el-tabs__header is-top"
    );
    // 使用原生js 为单个dom绑定鼠标右击事件
    tab_top_dom[0].oncontextmenu = this.openContextMenu;
  },
  computed: {
    openTab() {
      return this.$store.state.tabView.openTabs;
    },
    activeIndex: {
      get() {
        return this.$store.state.tabView.activeIndex;
      },
      set(val) {
        this.$store.commit("tabView/SET_ACTIVE_INDEX", val);
      },
    },
  },
  watch: {
    //进行路由监听
    $route(to, from) {
      //判断路由是否已经打开
      //已经打开的 ，将其置为active
      //未打开的，将其放入队列里
      let flag = false;
      if (
        to.path == "/custom/index" ||
        to.path == "/custom/indexPage" ||
        to.path == "/Microfront" ||
        to.path == "/systemMicrofront"
      ) {
        //处理url特殊符号
        let fullPath = to.fullPath;
        fullPath = StringTool.escapeUrlOfStr(fullPath);
        for (let item of this.openTab) {
          if (item.route === fullPath) {
            this.$store.commit("tabView/SET_ACTIVE_INDEX", fullPath);
            flag = true;
            break;
          }
        }

        if (!flag) {
          const pageItem = this.$store.state.user.menuList.find((obj) => {
            return obj.pagePath == fullPath;
          });
          //解决相同文件。不同参数的问题
          this.$store.commit("tabView/ADD_TAB", {
            route: to.fullPath,
            name: pageItem.name,
            closable: true,
          });
          this.$store.commit("tabView/SET_ACTIVE_INDEX", to.fullPath);
        }
      } else {
        for (let item of this.openTab) {
          if (item.route === to.path) {
            this.$store.commit("tabView/SET_ACTIVE_INDEX", to.path);
            flag = true;
            break;
          }
        }

        if (!flag) {
          const pageItem = this.$store.state.user.menuList.find((obj) => {
            return obj.pagePath === to.path;
          });
          this.$store.commit("tabView/ADD_TAB", {
            route: to.path,
            name: pageItem.name,
            closable: true,
          });
          this.$store.commit("tabView/SET_ACTIVE_INDEX", to.path);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.contextmenu {
  width: 100px;
  margin: 0;
  border: 1px solid #ccc;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.2);
}
.contextmenu li {
  margin: 0;
  padding: 0px 22px;
}
.contextmenu li:hover {
  background: #f2f2f2;
  cursor: pointer;
}
.contextmenu li button {
  color: #2c3e50;
}
</style>
<style lang="scss">
.tab-wrapper {
  width: calc(100% - 180px);
  height: 100%;
  .el-tabs--border-card {
    // margin-top: 1px;
    border-top: 0px;
    background: #e6f7ff;
    box-shadow: none;
    border: none;
  }
  .el-tabs {
    // margin-top: -2px;
    background: #e6f7ff;
    .el-tabs__header {
      background: #e6f7ff;
      margin: 0 0 0px;
      border-bottom: 0px;
    }
    .el-tabs__content {
      padding: 0px;
      border-bottom: 0px;
      .el-tab-pane {
        height: 100%;
      }
    }
  }

  .el-tabs--border-card {
    // border: 0px;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-right-color: #dcdfe6;
    border-left-color: #dcdfe6;
  }
}
</style>
